<lh-shared-ui-spinner *ngIf="isLoading"></lh-shared-ui-spinner>
<lh-user-active-booking [booking]="booking" (userActiveChange)="refreshBooking($event)"></lh-user-active-booking>

<div class="fl-1">
  <div id="bookingContainer" class="booking-timeline-content" *ngIf="booking">
    <div class="info-header fixed" *ngIf="!inlineTimerMode">
      <div class="container-fluid lh-container-fluid-sm">
        <lh-storage-timer
          [booking]="booking"
          [isCheckInSession]="isCheckInSession"
          (click)="explainStorageTimer()"
        ></lh-storage-timer>
      </div>
    </div>

    <div
      class="container-fluid lh-container-fluid-sm main-container"
      [class.inline-timer]="inlineTimerMode"
      [class.tab-bar-padding]="isTabbedNavigationEnabled"
    >
      <div class="storage-location-item" [class.mt-4]="alertMessage">
        <a id="viewStorageLocation" class="href" (click)="viewStorageLocation()">
          <div class="storage-location-media">
            <img [src]="storageLocationImage" />
          </div>

          <div class="storage-location-body">
            <strong>{{ 'YOUR_STORAGE_LOCATION' | translate }}</strong>
            <div class="storage-location-desc">
              <span *ngIf="!isDirectionsVisible">
                {{ 'GET_DIRECTIONS' | translate }}
              </span>
              <span *ngIf="isDirectionsVisible"> {{ booking.shopName }}, {{ booking.address.street }} </span>
            </div>
            <div class="shop-rating">
              <small class="avg-rating">{{ averageRating | number: '1.1-1' }}</small>
              <rating [(ngModel)]="averageRating" [max]="numberOfStars" [readonly]="true"></rating>
              <small *ngIf="showNumberOfReviews" class="no-reviews"
                >{{ numberOfReviews }} {{ 'REVIEWS' | translate | lowercase }}</small
              >
            </div>
            <div class="get-directions-cta">
              <button id="getDirectionsFromBookingStorageLocationItem" class="btn btn-sm btn-link">
                Get directions
              </button>
            </div>
          </div>
        </a>
      </div>

      <!-- Booking alert -->
      <div
        *ngIf="alertMessage"
        class="alert booking-alert"
        [class.no-timer-header]="inlineTimerMode"
        [class.alert-success]="isSuccessAlert"
        [class.alert-danger]="isDangerAlert"
        [class.alert-warning]="isWarningAlert"
      >
        <div class="alert-message">
          {{ alertMessage }}
          <a
            [id]="'showAlertActionLink_' + alertAction.name"
            *ngIf="alertAction"
            class="href alert-cta"
            (click)="onAlertClicked()"
          >
            {{ alertAction.callToAction }}
          </a>
        </div>

        <button
          [id]="'dismissAlert_' + (alertAction ? alertAction.name : 'NoAction')"
          type="button"
          class="btn-dismiss pull-right"
          aria-label="Dismiss"
          (click)="dismissAlert()"
        >
          <svg viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </button>
      </div>

      <div *ngIf="alertMessage" class="mb-4"></div>

      <!-- Booking action buttons -->
      <div class="booking-actions">
        <!-- Share booking -->
        <div class="dropdown" dropdown *ngIf="isSharingAvailable || isClipboardAvailable">
          <!--Dropdown toggle button-->
          <button id="shareBookingFromBookingTimeline" class="btn btn-default" type="button" dropdownToggle>
            <i>
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                fill="#384347"
                width="16"
                height="16"
                viewBox="0 0 26 26"
              >
                <title>ios_share</title>
                <path
                  d="M15.984 5.016l-1.406 1.406-1.594-1.594v11.156h-1.969v-11.156l-1.594 1.594-1.406-1.406 3.984-4.031zM20.016 9.984v11.016q0 0.844-0.586 1.43t-1.43 0.586h-12q-0.844 0-1.43-0.586t-0.586-1.43v-11.016q0-0.797 0.586-1.383t1.43-0.586h3v1.969h-3v11.016h12v-11.016h-3v-1.969h3q0.844 0 1.43 0.586t0.586 1.383z"
                ></path>
              </svg>
            </i>
            {{ 'SHARE_BOOKING' | translate }}
          </button>
          <!--Dropdown list-->
          <ul class="dropdown-menu dropdown-menu-right" *dropdownMenu role="menu" aria-labelledby="share-actions">
            <!-- Copy link item -->
            <li *ngIf="isClipboardAvailable">
              <a id="copyLinkToBooking" class="href" (click)="shareBookingCopyToClipboard()">
                <i>
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="#384347"
                    width="20"
                    height="20"
                    viewBox="0 0 28 28"
                  >
                    <title>link</title>
                    <path
                      d="M17.016 6.984q2.063 0 3.516 1.477t1.453 3.539-1.453 3.539-3.516 1.477h-4.031v-1.922h4.031q1.266 0 2.18-0.914t0.914-2.18-0.914-2.18-2.18-0.914h-4.031v-1.922h4.031zM8.016 12.984v-1.969h7.969v1.969h-7.969zM3.891 12q0 1.266 0.914 2.18t2.18 0.914h4.031v1.922h-4.031q-2.063 0-3.516-1.477t-1.453-3.539 1.453-3.539 3.516-1.477h4.031v1.922h-4.031q-1.266 0-2.18 0.914t-0.914 2.18z"
                    ></path>
                  </svg>
                </i>
                {{ 'COPY_LINK' | translate }}
              </a>
            </li>

            <!-- Share via... item -->
            <li *ngIf="isSharingAvailable">
              <a id="shareBookingVia" class="href" (click)="shareBookingVia()">
                <i>
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="#384347"
                    width="20"
                    height="20"
                    viewBox="0 0 28 30"
                  >
                    <title>ios_share</title>
                    <path
                      d="M15.984 5.016l-1.406 1.406-1.594-1.594v11.156h-1.969v-11.156l-1.594 1.594-1.406-1.406 3.984-4.031zM20.016 9.984v11.016q0 0.844-0.586 1.43t-1.43 0.586h-12q-0.844 0-1.43-0.586t-0.586-1.43v-11.016q0-0.797 0.586-1.383t1.43-0.586h3v1.969h-3v11.016h12v-11.016h-3v-1.969h3q0.844 0 1.43 0.586t0.586 1.383z"
                    ></path>
                  </svg>
                </i>
                {{ 'SHARE_VIA' | translate }}...
              </a>
            </li>
          </ul>
        </div>

        <!-- Booking options -->
        <lh-booking-options
          [booking]="booking"
          [storageLocation]="shop"
          (selectAction)="onAction($event)"
          class="me-1"
          [class.tab-bar-padding]="isTabbedNavigationEnabled"
          #bookingOptions
        >
        </lh-booking-options>
      </div>

      <h5>{{ 'BOOKING_TIMELINE' | translate }}</h5>

      <!-- Booking timeline -->
      <lh-booking-timeline
        [booking]="booking"
        [review]="review"
        [shop]="shop"
        [(strategy)]="strategy"
        (selectAction)="onAction($event)"
        (skipAction)="onAction($event, true)"
        #bookingTimeline
      >
      </lh-booking-timeline>
    </div>
  </div>

  <div class="order-summary-footer" *ngIf="showOrderSummary">
    <lh-ticket-stub dock="bottom">
      <lh-simple-order-summary
        [headline]="orderSummaryHeadline | translate"
        [isPaid]="isSettled"
        [isCanceled]="booking.status === 'CANCELLED'"
        [order]="order"
        [isReadOnly]="true"
        [callToAction]="orderSummaryActionInfo?.callToAction"
        (callToActionClick)="onAction(orderSummaryActionInfo)"
      ></lh-simple-order-summary>
    </lh-ticket-stub>
  </div>
</div>

<div
  [id]="modalId"
  class="modal fade"
  [class.modal-ios]="ios"
  bsModal
  #modal="bs-modal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="mySmallModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-fullscreen-sm" [class.full-height-no-footer]="isModalFullHeight">
    <div
      class="modal-content"
      [hidden]="!isModalReady"
      [class.modal-header-error]="modalError"
      [class.modal-header-warning]="modalWarning"
      [class.modal-header-success]="modalSuccess"
    >
      <div *ngIf="modalTitle" class="modal-header">
        <h4 class="modal-title pull-left" *ngIf="currentAction">
          <span
            [class.modal-title-error]="modalError"
            [class.modal-title-warning]="modalWarning"
            [class.modal-title-success]="modalSuccess"
          >
            {{ modalTitle }}
          </span>
          <div class="modal-subtitle">{{ modalSubtitle }}</div>
        </h4>

        <button
          [id]="'closeActionModal_' + currentAction.name"
          type="button"
          class="close pull-right"
          aria-label="Close"
          (click)="modal.hide()"
        >
          <svg viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </button>
      </div>

      <div #modalContent>
        <!-- Modal content will be dynamically insterted here -->
      </div>
    </div>
  </div>
</div>
